import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/authStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';

export function LoginPage() {
  const navigate = useNavigate();
  const { login, loading, error } = useAuth();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      await login(identifier, password);
      navigate('/home');
    } catch { /* error in store */ }
  }

  return (
    <div className="min-h-screen max-w-md mx-auto flex flex-col px-6 pt-12 pb-10">
      <div className="flex flex-col items-center gap-4 mb-10">
        <img src="/logo.jpg" alt="HMT DAO" className="w-24 h-24 rounded-2xl shadow-glow" />
        <div className="text-center">
          <h1 className="text-2xl font-extrabold tracking-[0.25em]">
            <span className="text-accent">HMT</span><span className="text-fg">DAO</span>
          </h1>
          <p className="mt-1 text-xs uppercase tracking-[0.3em] text-fg-muted">Member Portal</p>
        </div>
      </div>

      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          label="Email or username"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          autoComplete="username"
          required
        />
        <Input
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        {error && (
          <div className="p-3 rounded-xl bg-danger/10 border border-danger/30 text-danger text-sm">
            {error}
          </div>
        )}
        <Button type="submit" fullWidth size="lg" loading={loading}>Sign in</Button>
      </form>

      <p className="mt-8 text-center text-sm text-fg-muted">
        New member?{' '}
        <Link to="/register" className="text-accent font-semibold hover:text-accent-hover">Create account</Link>
      </p>
    </div>
  );
}
